export { clearError, setError, setSuccess, setProcessing } from '@/store/generic/mutations/result-status';

export function setDashboard(state, dashboard) {
  state.dashboard = dashboard;
}

export function setTopic(state, snapshot) {
  state.topic = snapshot;
  state.topicMissing = snapshot === null;
}

export function setRequeuePreview(state, preview) {
  state.requeuePreview = preview;
}

export function setRequeueCompleted(state, completed) {
  state.requeueCompleted = completed;
}

export function setRequeueElsewhere(state, elsewhere) {
  state.requeueElsewhere = elsewhere;
}
